import { nanoid } from 'nanoid';
import { ContentfulAttribute, LegacyContentfulAttribute } from '../types/types';

export const getNewAttribute = (): ContentfulAttribute => {
  return {
    name: '',
    values: [],
    id: nanoid(16)
  };
};

export const migrateLegacyAttribute = (legacyAttribute: LegacyContentfulAttribute): ContentfulAttribute => {
  return {
    name: legacyAttribute.attribute,
    values: [legacyAttribute.attributeValue],
    id: nanoid(16)
  };
};
